"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var utilityCardLocal = function utilityCardLocal() {
  return {
    appearance: {
      primary: {
        containerAppearance: 'primary',
        inverseText: false,
        iconGroup: 'midLight'
      }
    }
  };
};

var _default = utilityCardLocal;
exports["default"] = _default;
//# sourceMappingURL=UtilityCard.theme.js.map